﻿$.fn.dxCtrlWizardItem5ResaFinal = function custom_dxCtrlWizardItem5ResaFinal(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizarditem5resafinal dx-ctrl");
        this.createInstance(new cdxCtrlWizardItem5ResaFinal(this, option));
    }
    return this;
}

window.cdxCtrlWizardItem5ResaFinal = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.css("padding", "20px")
    }

    function mRempli() {
        container.empty()

        $("<div style='text-align:center;font-weight:bold;font-size:140%;'>Votre réservation est confirmée</div>").appendTo(container)

        $("<div style='padding:20px 0 10px 0;'>Un email vous a été envoyé sur <u>" + option.dataForResa.clDataSaisie.data.adresse_email + "</u></div>").appendTo(container)

        switch (parseInt(option.dataForResa.dataReservationArrhes.id_mode_reglement_demande)) {
            case 1: //cb
                $("<div>Votre paiement par carte bancaire a été validé.</div>").appendTo(container)
                break;
            case 2: //virement
                $("<div>Votre réservation est maintenant active sur notre planning.</div>").appendTo(container)
                $("<div>Nous attendons votre virement d'un montant de <b>" + parseFloat(option.dataForResa.dataReservationArrhes.mt).formatDisplay() + "€</b> sur le compte:</div>").appendTo(container)
                var objSociete = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("societe")[0])
                $("<div>" + objSociete.objetMetier.mGetLibHtmlVirement() + "</div>").appendTo(container)
                if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") > 0) {
                    var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                    $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo(container);
                }
                break;
            case 3: //cheque
                $("<div>Votre réservation est maintenant active sur notre planning.</div>").appendTo(container)
                $("<div>Nous attendons la réception de votre chèque d'un montant de <b>" + parseFloat(option.dataForResa.dataReservationArrhes.mt).formatDisplay() + "€</b>:</div>").appendTo(container)
                var objSociete = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("societe")[0])
                $("<div>Chèque: à l'ordre de <b>" + objSociete.objetMetier.mGetOrdreCheque() + "</b></div>").appendTo(container)
                var adresse = objSociete.objetMetier.mGetDataAdresse()
                if (adresse) {
                    var $DivAdr = $("<div style=''/>").appendTo(container)
                    var $DivAdr2 = $("<div><span style=''>Envoyer à: </div>").appendTo($DivAdr)
                    $("<span style='font-weight:bold;'>" + objSociete.data.nom + ", </span>").appendTo($DivAdr2)
                    var objAdr = new cAdresse(adresse)
                    objAdr.mGetAffichage1lineElement().appendTo($DivAdr2)
                }
                if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") > 0) {
                    var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                    $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo(container);
                }
                break;
            case 5: //cheque vacances
                $("<div>Votre réservation est maintenant active sur notre planning.</div>").appendTo(container)
                $("<div>Nous attendons la réception de vos chèques vacances d'un montant de <b>" + parseFloat(option.dataForResa.dataReservationArrhes.mt).formatDisplay() + "€</b>:</div>").appendTo(container)
                var objSociete = option.bddCtrl.getObjet(option.bddCtrl.mGetArray("societe")[0])
                var adresse = objSociete.objetMetier.mGetDataAdresse()
                if (adresse) {
                    var $DivAdr = $("<div style=''/>").appendTo(container)
                    var $DivAdr2 = $("<div><span style=''>Envoyer à: </div>").appendTo($DivAdr)
                    $("<span style='font-weight:bold;'>" + objSociete.data.nom + ", </span>").appendTo($DivAdr2)
                    var objAdr = new cAdresse(adresse)
                    objAdr.mGetAffichage1lineElement().appendTo($DivAdr2)
                }
                if (option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes") > 0) {
                    var dateEnd = (new Date()).addDays(option.bddCtrl.paraAppli.mGetPara("hebergement_temps_attente_arrhes"))
                    $("<div style='padding:5px 0;font-style:italic;font-size:80%;line-height:1;'>Votre réservation sera maintenue jusqu’au " + dateEnd.toDDMMAA() + " au soir. Passé ce délai, et sans réception des arrhes, celle-ci sera automatiquement annulée.</div>").appendTo(container);
                }
                break;
        }

        $("<div style='padding:20px 0 10px 0;'>Nous vous remercions d'avoir choisi notre établissement.</div>").appendTo(container)

        var $DivRecap = $("<div style='margin-top:30px;text-align:center;'/>").appendTo(container)
        option.bddCtrl.getObjet(option.dataForResa.dataReservation).objetMetier.mGetElementRecapitulatif().appendTo($DivRecap)

    }

    this.mIsActivated = function () {
        mRempli()
    }

    this.btPreviousVisible = function () {
        return false
    }
    this.btNextVisible = function () {
        return false
    }

    this.mGetClassIconeForLstItem = function () {
        return "fas fa-handshake"
    }
    this.hasHeight100Percent = function () { return true }
    this.title = function () { return "Résumé de votre réservation" }
    this.mGetProprieteImage = function () {
        var urlFond = ""
        var lstImage = JSON.parse(option.bddCtrl.paraAppli.mGetPara("hebergement_resa_internet_list_image_arriere_plan"))
        if (lstImage.length > 0) {
            var idxImage = Math.floor(Math.random() * lstImage.length)
            var urlFond = lstImage[idxImage]
        } else {
            var idxImage = Math.floor(Math.random() * 20) + 1;
            var urlFond = parametre.urldispatch + "/img/imglogin/" + parametre.baseAppli.code_appli_general + "/img" + idxImage + ".jpg"
        }
        return {
            url: urlFond,
            position: (parametre.isPhone ? "Gauche" : "Droite")
        }
    }

    this.mGetUrlLink = function () {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        return parametre.url_appli.replace("app.", "appgo.") + "/" + option.bddCtrl.nom_base + "/" +
            "4/reservation"
    }

    this.mGetIndexFromUrlLink = function (locationPathname) {
        //https://xxxxx.xxxxxx.eu/nom_base/id_page/reservation
        //locationPathname=/nom_base/id_page/reservation
        return locationPathname.split("/")[2]
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}